import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';

@Component({
  selector: 'app-working-hours',
  templateUrl: './working-hours.component.html',
  styleUrls: ['./working-hours.component.css']
})
export class WorkingHoursComponent extends BaseListCtl {

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.WORKINGHOURS,locator,route);
  }

  populateForm(form, data) {
    form.id = data.id;
    form.name = data.name;
    form.userId=data.userId;
    form.userName=data.userName;
    form.startTime=data.startTime;
    form.stopTime=data.stopTime;
    form.timeDifference=data.timeDifference;
    form.timeMilisec=data.timeMilisec;
    form.prdDate=data.prdDate;
    form.status=data.status;
    
    console.log('----->',data);
  }


  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    }
    return null;
}
}